import { FormattedMessage } from 'react-intl'
import { Label, List, Section } from '../../../../../../../Components/shared/Navbar'
import { BuyerLinks } from './BuyerLinks'
import { HomeSearchLinks } from './HomeSearchLinks'

export const FindAHomeLink = () => {
  return (
    <Section>
      <Label>
        <FormattedMessage
          id='YourHomeLink.findAHome.label'
          defaultMessage='Find a home'
        />
      </Label>
      <List>
        <HomeSearchLinks />
        <BuyerLinks />
      </List>
    </Section>
  )
}
